const breadCrumb = "Lançamento de Notas - Lançar Justificativas";

const routes = [
  {
    path: "/emitir-relatorio-justificativa-faltas",
    name: "mitir-relatorio-justificativa-faltas",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/EmitirRelatorioJustificativaFaltas/EmitirRelatorioJustificativaFaltas.vue"
      ),
  },
];

export default routes;
